import React from 'react'
import './index.scss'
import CheckMarkIcon from '../../../asset/CheckMarkIcon.png'
import { connect } from 'react-redux'
import { closeThreeDWelcomePopup } from '../../action/threed-maps-actions'

const WelcomePage = (props) => {
  return (
    <div className="threed-map-welcome-popup-contianer">
      <div className="popup-threed-contianer">
        <div className="popup-container-threed">

          <h2>Welcome to 3D BETA</h2>

          <div className="popup-content">
            {/* <!-- Left Column --> */}
            <div className="popup-section">
              <h3>Available Now</h3>
              <ul className="available">
                <li>
                  <img src={CheckMarkIcon}></img><p>Hi-Res 3D Terrain</p></li>
                <li>
                  <img src={CheckMarkIcon}></img><p>View Markers</p></li>
                <li>
                  <img src={CheckMarkIcon}></img><p>View Photo Markers</p></li>
              </ul>
            </div>

            {/* <!-- Right Column --> */}

            <div className="popup-section">
              <h3>Coming Soon</h3>
              <ul className="available">
                <li ><span style={{ color: '#1d1d1d' }}>-</span><p style={{ color: '#1d1d1d' }}>View map layers</p></li>
                <li ><span style={{ color: '#1d1d1d' }}>-</span><p style={{ color: '#1d1d1d' }}>View tracks</p></li>
                <li ><span style={{ color: '#1d1d1d' }}>-</span><p style={{ color: '#1d1d1d' }}>Add map objects</p></li>
              </ul>
            </div>
          </div>

          <p className="feedback">
            Please leave your feedback at support@basemap.com
          </p>

          <button className="got-it-btn" onClick={() => { props.closeThreeDWelcomePopup() }}>GOT IT</button>
        </div>
      </div>
    </div >
  )
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
  closeThreeDWelcomePopup: () => dispatch(closeThreeDWelcomePopup())
})

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage)
